import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('curtain', ['show']),
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/base/curtain/component.js